import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Function to initialize the React app
function initializeApp() {
  // Look for root element
  let rootElement = document.getElementById('root');
  
  // If no root element exists, create one (for embed compatibility)
  if (!rootElement) {
    rootElement = document.createElement('div');
    rootElement.id = 'root';
    document.body.appendChild(rootElement);
    console.log('Chat Widget: Created root element automatically');
  }

  // Create React root and render
  const root = ReactDOM.createRoot(rootElement);
  root.render(<App />);

  // Store references for embed script compatibility
  (window as any).chatWidgetReactRoot = root;
  (window as any).chatWidgetRootElement = rootElement;

  console.log('Chat Widget: React app initialized');
  
  return root;
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
